import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  APPLICATION_STATUSES_FEATURE_KEY,
  ApplicationStatusesState,
} from './application-statuses.reducer';

export const getApplicationStatusesState =
  createFeatureSelector<ApplicationStatusesState>(
    APPLICATION_STATUSES_FEATURE_KEY
  );

export const getStatuses = (typeId: string) =>
  createSelector(
    getApplicationStatusesState,
    (state: ApplicationStatusesState) => state.statuses?.get(typeId)
  );

export const getStatusesLoaded = (typeId: string) =>
  createSelector(
    getApplicationStatusesState,
    (state: ApplicationStatusesState) => state.loaded?.get(typeId)
  );

export const getStatusesLoading = (typeId: string) =>
  createSelector(
    getApplicationStatusesState,
    (state: ApplicationStatusesState) => state.loading?.get(typeId)
  );

export const getError = createSelector(
  getApplicationStatusesState,
  (state: ApplicationStatusesState) => state.error
);

